// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"c07352eb","455":"2ab89706","977":"52d2d253"}[chunkId] + ".chunk.js";
};